import { useState } from "react";
import "./todoForm.css";

const TodoForm = ({ addTodo }) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addTodo(value);
    setValue("");
  };

  return (
    <form className="TodoForm" onSubmit={handleSubmit}>
      <input
        type="text"
        className="todo-input"
        placeholder="What is the task today?"
        value={value}
        onChange={(e) => handleChange(e)}
      ></input>
      <button type="submit" className="todo-btn click">
        Add Task
      </button>
    </form>
  );
};

export default TodoForm;
